import { colors, COLORS } from '@constants/colors';
import { IStyles } from '@interfaces/styles';

export const useStyles = (isOnline = false) => ({
  root: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  rootPosition: {
    display: 'flex',
    alignItems: 'center',
    width: isOnline ? 'calc(100% - 92px)' : '100%',
  },

  userAvatar: {
    position: 'relative',
  },

  statusIcon: {
    position: 'absolute',
    top: 0,
    right: 0,
  },

  avatar: {
    width: 32,
    height: 32,
    fontSize: '1rem',
  },

  usernameWrapper: (isFacilitator: boolean) => {
    return isFacilitator
      ? ({
          display: 'flex',
          alignItems: 'start',
          margin: '0 0 0 8px',
          flexDirection: 'column',
          width: 'calc(100% - 24px)',
        } as IStyles)
      : ({
          padding: '4px 4px 0 8px',
          width: 'calc(100% - 24px)',
        } as IStyles);
  },

  username: {
    color: colors.white,
    fontSize: 16,
    lineHeight: '87%',
    letterSpacing: '0.04em',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: isOnline ? '94%' : '100%',
    textOverflow: 'ellipsis',
    height: '20px',
  } as IStyles,

  micIcon: {
    color: COLORS.WHITE,
    ml: 1,
  },

  tools: {
    display: 'flex',
    gap: '10px',
  },

  iconButton: {
    p: 0,
    width: 24,
    height: 24,
    minWidth: 0,
    display: 'block',
  },

  iconButtonTeleport: {
    p: 0,
    height: 24,
    minWidth: 0,
    display: 'block',
    color: COLORS.WHITE,
  },

  icon: {},
});
